export default __webpack_public_path__ + "static/media/flag-en.3b671736.svg";